import { render, staticRenderFns } from "./BottomChart.vue?vue&type=template&id=5b3aaa79&scoped=true&"
import script from "./BottomChart.vue?vue&type=script&lang=js&"
export * from "./BottomChart.vue?vue&type=script&lang=js&"
import style0 from "./BottomChart.vue?vue&type=style&index=0&id=5b3aaa79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3aaa79",
  null
  
)

component.options.__file = "BottomChart.vue"
export default component.exports